"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setData = exports.resetData = exports.getData = exports.failGetData = exports.autoSelectByParentID = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    // eslint-disable-next-line max-params
    autoSelectByParentID: function autoSelectByParentID(countryID, parentID, cities, provinces, districts, setter) {
      return {
        countryID: countryID,
        parentID: parentID,
        cities: cities,
        provinces: provinces,
        districts: districts,
        setter: setter
      };
    },
    getData: function getData(countryID, withPrice) {
      return {
        countryID: countryID,
        withPrice: withPrice
      };
    },
    setData: function setData(key, data) {
      return {
        key: key,
        data: data
      };
    },
    resetData: function resetData(key) {
      return key;
    },
    failGetData: function failGetData(error) {
      return error;
    }
  }, {
    prefix: 'GEO_TREE_CONTROL'
  }),
  autoSelectByParentID = exports.autoSelectByParentID = _createActions.autoSelectByParentID,
  getData = exports.getData = _createActions.getData,
  setData = exports.setData = _createActions.setData,
  resetData = exports.resetData = _createActions.resetData,
  failGetData = exports.failGetData = _createActions.failGetData;